import React from "react";
import classNames from "classnames";
import LabelWithTooltip from "../labelWithTooltip";
import { TabsMenuWrapperArgsType, TabType } from "./type";

function TabsMenuWrapper<TabIdEnum = string>({
  tabs,
  activeTabId,
  setActiveTabId,
  additionalClassName,
  hideTabIfSingleEntry,
  overrideCssProperties
}: TabsMenuWrapperArgsType<TabIdEnum>) {
  const [activeTab, setActiveTab] = React.useState<TabType<TabIdEnum>>();

  React.useEffect(() => {
    const currentActiveTab = tabs?.find(tab => tab.id === activeTabId);
    setActiveTab(currentActiveTab ? currentActiveTab : tabs[0]);
  }, [activeTabId, tabs]);

  const tabClickHandler = React.useCallback(
    async (item: TabType<TabIdEnum>) => {
      if (activeTab?.tabInactiveHook) {
        try {
          const response = await activeTab?.tabInactiveHook();
          if (!response) {
            return;
          }
        } catch (e) {}
      }
      setActiveTab(item);
      setActiveTabId?.(item.id);
    },
    [activeTab, setActiveTabId]
  );

  const hideTab = React.useMemo(() => tabs.length === 1 && hideTabIfSingleEntry, [hideTabIfSingleEntry, tabs.length]);

  return (
    <div
      className={classNames("tab_wrapper", additionalClassName)}
      style={
        {
          "--tabBorderColor": overrideCssProperties?.primary
        } as React.CSSProperties
      }>
      <div className={classNames("tab_wrapper_head", { hide: hideTab })}>
        <ul className="list-inline tab_wrapper_list">
          {tabs?.map((item: TabType<TabIdEnum>, idx: number) => {
            return (
              <li key={idx} className="tab_wrapper_list_item" title={item.tooltip}>
                <span
                  role="button"
                  className={classNames("tab_wrapper_list_item-title", {
                    active: activeTab?.id === item.id,
                    disabled: item.disabled
                  })}
                  onClick={() => {
                    item.disabled || tabClickHandler(item);
                  }}>
                  {typeof item.title === "string" ? (
                    <small>
                      <LabelWithTooltip label={item.title} tooltipContent={item.tooltip} />
                    </small>
                  ) : (
                    item.title
                  )}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="tab_wrapper_body" key={activeTab?.id?.toString()}>
        {tabs.find(i => i.id === activeTab?.id)?.component}
      </div>
    </div>
  );
}

export default TabsMenuWrapper;
